import React from 'react';
import styles from './styles.module.css';
import { memo } from 'react';
import i18n, { t } from 'i18next';

type DeviceNotificationProps = {
    activeThemeIndex: number;
};

const DeviceNotification = memo(({ activeThemeIndex }: DeviceNotificationProps) => {
    const y = -20; //基準高さ

    // 言語切り替えチケット名と同様に、タップして日本語と設定言語で切り替える。
    const lng = activeThemeIndex === 0 ? i18n.language : 'ja';

    return (
        <div className={styles.deviceNotificationContainer}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox={`0 -20 206 226`} width="100%" height="100%">
                <foreignObject x={0} y={y} width="200" height="221">
                    <div
                        style={{
                            backgroundColor: '#ffffff',
                            border: 'solid 2px #ff0000',
                            borderRadius: 8,
                            whiteSpace: 'pre-wrap',
                            height: '100%',
                        }}
                    >
                        <p style={{ fontSize: '13px', color: '#000000', fontWeight: 'bold', paddingTop: 22 }}>
                            {t('ticket-display.multiple-use', { lng })}
                        </p>
                        <p
                            style={{
                                fontSize: '9px',
                                fontWeight: 'bold',
                                color: '#000000',
                                paddingTop: 18,
                                paddingLeft: 12,
                                paddingRight: 12,
                                textAlign: 'left',
                            }}
                        >
                            {t('ticket-display.change-browser', { lng })}
                        </p>
                    </div>
                </foreignObject>
            </svg>
        </div>
    );
});

export default DeviceNotification;
